// eslint-disable-next-line import/prefer-default-export,consistent-return
export const getRunnerPromotionConfig = ({ promotions }) => {
    if (
        !promotions ||
        !promotions.enabled ||
        !promotions.runner ||
        !promotions.runner.enabled
    ) {
        return {
            enabled: false,
            eventPath: null
        };
    }

    if (promotions.runner && promotions.runner.enabled) {
        return promotions.runner;
    }

    return {
        enabled: false,
        eventPath: null
    };
};
